// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function () {  // Add this
	
	BoostPFS.inject(this);  // Add this
	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
	};
  
    InstantSearchMobile.prototype._onFocusSearchBox = function(event) {
		if (Utils.isFullWidthMobile()) {
			// Open the instant search box when focus on the theme search input
			if (!jQ(event.target).is(this.$searchInput)) {
				this.$targetInput = jQ(event.target);
				this.showSearchBoxMobile();
				this.$searchInput.trigger('click');
			}
          if(Utils.isiOS()){
            if (!jQ('body').hasClass("suggestion-focus")) {
              jQ('body').addClass("suggestion-focus");
            }
          }
		}
	}
    
    InstantSearchMobile.prototype.bindEvents = function() {
		this.$searchInput = jQ(this.selector.searchInput);
		this.$clearButtonElement = jQ(this.selector.clearButton);
		this.$closebuttonElement = jQ(this.selector.closebutton);
		this.$submitButtonElement = jQ(this.selector.submitButton);
		this.$topPanelElement = jQ(this.selector.topPanel);
		this.$overlayElement = jQ(this.selector.overlay);
		
		// apply autocomplete for search input
		this.searchBox = new SearchInput(this.inputMobileId, this.$searchInput);
		this.searchBox.refresh();

		// Add close button event
		this.$closebuttonElement.on('click', this.closeInstantSearchMobile.bind(this, true));
		// Add clear button event
		this.$clearButtonElement.on('click', this.clearInstantSearchMobile.bind(this));

		this.$searchInputs = jQ(this.selector.searchInputs);
		this.$searchInputs
			.on('click', this._onClickSearchBox.bind(this))
			.on('focus', this._onFocusSearchBox.bind(this))
			.on('keyup', this._onTypeSearchBoxEvent.bind(this))
        	.on('blur' , function(){
                if(Utils.isiOS()){
                    if (jQ('body').hasClass("suggestion-focus")) {
                      jQ('body').removeClass("suggestion-focus");
                    }
                }
            });
		this.$targetInput = null;

		this.isBoundEvents = true;
	}
})();  // Add this at the end